module.exports = __webpack_public_path__ + "img/frame (260).b140e653.jpg";